var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-wrapper"},[_c('div',{staticClass:"subpage__inner"},[_c('SubpageNav',{attrs:{"links":_vm.links}}),_c('transition',{attrs:{"name":"fade-up"}},[_c('router-view')],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }